export default "__VITE_ASSET__CviFvGsV__"